import Form from '../form';
const form = new Form;

export const getSiteData = async () => await form.get('/setting/common');